<template>
  <div class="editBG pt-3 mt-4">
    <!-- <v-snackbar
      v-model="snackbar"
      auto-height
      right
      flat
      top
      :timeout="timeout"
      vertical
      :color="snackbarColor"
    >
      {{ humanize(this.snackbarFieldName) }} saved.
    </v-snackbar> -->

    <v-layout
      row
      wrap
      style="
        background-color: white;
        height: 30px;
        width: 100%;
        top: 135px;
        position: fixed;
        z-index: 1;
        height: 50px;
      "
    >
      <v-flex xs12> </v-flex>
    </v-layout>

    <v-toolbar
      tabs
      color="white"
      class="elevation-1 mt-2"
      style="top: 155px; position: fixed; z-index: 1"
    >
      <h4
        class="pl-3 headline font-weight-light"
        v-html="location_get.name"
      ></h4>
      <!-- <v-toolbar-title class="pl-4">{{ location_get.name }} </v-toolbar-title> -->
      <v-spacer></v-spacer>
      <!-- <a
        class="headline mr-2 pr-2 black--text"
        @click="
          options = false;
          $router.go(-1);
        "
        >close</a
      > -->
      <v-btn
        v-if="c_user.delete_rights"
        small
        icon
        class="mr-3"
        @click="$router.go(-1)"
        right
      >
        <v-icon small color="red">delete</v-icon>
      </v-btn>
      <v-btn small icon class="mr-3" @click="$router.go(-1)" right>
        <v-icon small>close</v-icon>
      </v-btn>
      <v-btn icon small :disabled="!valid" @click="save" right>
        <v-icon small>save</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- <v-layout
      mx-0
      pl-4
      ml-0
      mt-0
      pb-3
      style="
        padding-top: 30px;
        position: fixed;
        z-index: 1;
        top: 160px;
        width: 100%;
      "
      class="editBG"
    > -->
    <!-- <v-flex class="xs12 pl-3">
        <v-flex class="pb-0 mb-0 xs8">
          <h4 class="headline font-weight-bold py-0 my-0">
            {{ location_get.name }}
          </h4>
        </v-flex>
      </v-flex> -->
    <!-- <v-spacer></v-spacer> -->

    <!-- <a
        class="headline mr-4 pr-3 black--text"
        @click="
          options = false;
          $router.go(-1);
        "
        >close</a
      > -->
    <!-- </v-layout> -->

    <v-form @submit.prevent ref="form" v-model="valid" lazy-validation>
      <v-card class="pl-2 pr-2 pt-4 mt-4 elevation-0 editBG">
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex
              style="background-color:#292929; color: #eee;"
              class="px-3 py-0 mx-2 my-3 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">Basic</h3>
            </v-flex>

            <v-flex xs12 class="px-3 mt-1">
              <v-text-field
                v-model="location_get.name"
                label="Location Name"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 class="px-3">
              <v-text-field
                v-model="location_get.city"
                label="city"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 px-3>
              <v-autocomplete
                :items="this.countries"
                v-model="location_get.country_id"
                label="Select Country"
                clearable
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm12 md12 px-3>
              <v-textarea
                auto-grow
                clearable
                rows="1"
                v-model="location_get.admin_note"
                label="Note"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- <v-card-actions class="mx-4 my-3">
          <v-flex xs12 sm12 md12>
            <v-spacer></v-spacer>
            <v-btn dark class="right" @click="this.save">SAVE</v-btn>
            <v-btn
              class="right mr-3"
              color="black"
              outline
              @click="$router.go(-1)"
              >CANCEL</v-btn
            >
          </v-flex>
        </v-card-actions> -->

        <v-container grid-list-xs fluid ml-3 pr-5 mt-0 pt-0>
          <v-layout row wrap>
            <v-flex xs12>
              <h3 class="pb-2">
                List of artworks currently at this location ({{
                  artworks.length
                }})
              </h3>
              <v-list two-line class="mr-2">
                <v-list-tile v-for="a in artworks" :key="a.id">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <router-link
                        :to="{
                          name: 'EditArtwork',
                          params: { id: a.id, artwork: a },
                          path: `/artworks/edit/${a.id}`
                        }"
                      >
                        {{ a.title }}
                      </router-link>
                      <a
                        v-bind:href="
                          `${$globals.oldserver}/artworks/edit/${a.id}`
                        "
                        style="margin: 10px"
                        icon
                        ><v-icon small>open_in_new</v-icon></a
                      >
                    </v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      a.full_name
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import constants from '@/data/constants'
import axios from '@/utils/apiClient'
import { serverBus } from '../../main'

export default {
  data() {
    return {
      constants: constants,
      location_get: {},
      valid: true,
      // snackbarFieldName: 'Location',
      // snackbarColor: 'green',
      // snackbar: false,
      timeout: 3000,
      countries: constants.COUNTRIES,
      editContact: false,
      artworks: this.$store.state.artworks.filter(
        a => a.artwork_location_id == this.location.id
      )
    }
  },
  beforeMount() {
    this.getLocation()
  },
  computed: {
    location_local() {
      return Object.assign({}, this.location)
    }
  },
  methods: {
    getLocation() {
      let url = `${this.$globals.apiserver}/artwork_locations/${this.location.id}.json`
      axios
        .get(url)
        .then(response => {
          this.location_get = response.data
        })
        .catch(error => {
          // console.log(error)
        })
    },
    humanize(t) {
      return t.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function(t) {
        return t.toUpperCase()
      })
    },
    save() {
      serverBus.$emit('showSnackbar', 'Saving location.', 'green')
      /// kvoli mazaniu aktualnej hodnoty - autocomplete totiz vracia undefined ak je prazdny a potom neposle field vobec a preto nevymaze v rails hodnotu
      this.location_get.country_id = this.location_get.country_id
        ? this.location_get.country_id
        : ''
      this.location_get.updated_by = this.c_user.id
      let url = `${this.$globals.apiserver}/artwork_locations/${this.location.id}.json`
      axios
        .put(url, this.location_get)
        .then(response => {
          this.result = response.data
          serverBus.$emit('showSnackbar', 'Location saved.', 'green')
          // this.snackbar = true
          // this.snackbarColor = 'green'
          this.$store.dispatch('replaceObject', {
            item: { item: response.data, table: 'locations' }
          })
        })
        .catch(error => {
          serverBus.$emit('showSnackbar', 'Error occured.', 'red')
          // console.log(error)
        })
    }
  },
  props: ['location']
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: #666;
}
a:hover {
  text-decoration: none;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/locations/EditLocation.vue